import axios from "axios";
import {baseUrl} from "../Univ";
import TokenStorage from "./ABDMStorage";
import WorkflowStorage from "./ABDMWorkflowStorage";
// ============================================================
// AXIOS INSTANCE
// ============================================================
const ABDMApi = axios.create({
    baseURL: baseUrl, headers: {
        "Content-Type": "application/json"
    }
});
// ============================================================
// CLEAN VALUE
// ============================================================
const clean = (value) => {
    if (value === undefined || value === null) return value;
    if (typeof value !== "string") return value;
    return value.replace(/^"+|"+$/g, "");
};
// ============================================================
// SAVE WORKFLOW VALUE
// ============================================================
const saveWorkflowValue = (key, value) => {
    if (value === undefined || value === null || value === "") {
        return;
    }
    const cleanedValue = clean(value);
    WorkflowStorage.save(key, cleanedValue);
};
// ============================================================
// SAVE ABHA ACCOUNT
// ============================================================
const saveABHAAccount = (account) => {
    if (!account || typeof account !== "object") {
        return;
    }
    // ========================================================
    // ABHA NUMBER
    // ========================================================
    if (account.ABHANumber) {
        const abhaNumber = clean(account.ABHANumber);
        TokenStorage.saveAbhaNumber(abhaNumber);
        WorkflowStorage.save("abhaNumber", abhaNumber);
    }
    // ========================================================
    // ABHA ADDRESS
    // ========================================================
    if (account.preferredAbhaAddress) {
        const abhaAddress = clean(account.preferredAbhaAddress);
        TokenStorage.saveAbhaAddress(abhaAddress);
        WorkflowStorage.save("abhaAddress", abhaAddress);
    }
    // ========================================================
    // PROFILE
    // ========================================================
    WorkflowStorage.save("profile", account);
    TokenStorage.saveProfile(account);
};
const handleABHAOTPVerifyResponse = (data) => {
    if (!data || typeof data !== "object") {
        return;
    }
    console.log("========================================");
    console.log("ABHA OTP VERIFY RESPONSE");
    console.log(data);
    console.log("========================================");
    // ========================================================
    // NEW TRANSACTION ID
    // ========================================================
    if (data.txnId) {
        const txnId = clean(data.txnId);
        TokenStorage.saveTxnId(txnId);
        WorkflowStorage.save("txnId", txnId);
    }
    // ========================================================
    // TOKEN
    //
    // IMPORTANT:
    //
    // OTP VERIFY TOKEN IS T-TOKEN
    //
    // DO NOT SAVE THIS AS X-TOKEN
    // ========================================================
    if (data.token) {
        const tToken = clean(data.token);
        TokenStorage.saveTToken(tToken);
        WorkflowStorage.save("tToken", tToken);
    }
    // ========================================================
    // OPTIONAL EXPIRY
    // ========================================================
    if (data.expiresIn !== undefined) {
        WorkflowStorage.save("expiresIn", data.expiresIn);
    }
    // ========================================================
    // AUTH RESULT
    // ========================================================
    if (data.authResult) {
        WorkflowStorage.save("authResult", data.authResult);
    }
    // ========================================================
    // MESSAGE
    // ========================================================
    if (data.message) {
        WorkflowStorage.save("message", data.message);
    }
    // ========================================================
    // ACCOUNTS
    // ========================================================
    if (Array.isArray(data.accounts) && data.accounts.length > 0) {
        WorkflowStorage.save("accounts", data.accounts);
        // ----------------------------------------------------
        // FIRST ACCOUNT
        // ----------------------------------------------------
        saveABHAAccount(data.accounts[0]);
    }
};
// ============================================================
// NORMAL WORKFLOW EXTRACTOR
//
// Used for normal APIs.
//
// IMPORTANT:
//
// "token" is NOT automatically xToken anymore.
//
// Different APIs use token differently.
// ============================================================
const extractWorkflowData = (obj) => {
    if (!obj) return;
    // ========================================================
    // ARRAY
    // ========================================================
    if (Array.isArray(obj)) {
        obj.forEach(item => extractWorkflowData(item));
        return;
    }
    // ========================================================
    // NON OBJECT
    // ========================================================
    if (typeof obj !== "object") {
        return;
    }
    Object.entries(obj)
        .forEach(([key, value]) => {
            switch (key) {


                // ========================================
                // ACCESS TOKEN
                // ========================================
                case "accessToken":
                    TokenStorage.saveAccessToken(clean(value));
                    WorkflowStorage.save("accessToken", clean(value));
                    break;


                // ========================================
                // X TOKEN
                // ========================================
                case "xToken":
                    TokenStorage.saveXToken(clean(value));
                    WorkflowStorage.save("xToken", clean(value));
                    break;


                // ========================================
                // T TOKEN
                // ========================================
                case "tToken":
                    TokenStorage.saveTToken(clean(value));
                    WorkflowStorage.save("tToken", clean(value));
                    break;


                // ========================================
                // TXN ID
                // ========================================
                case "txnId":
                    TokenStorage.saveTxnId(clean(value));
                    WorkflowStorage.save("txnId", clean(value));
                    break;


                // ========================================
                // ABHA NUMBER
                // ========================================
                case "abhaNumber":
                    TokenStorage.saveAbhaNumber(clean(value));
                    WorkflowStorage.save("abhaNumber", clean(value));
                    break;


                // ========================================
                // ABHA NUMBER
                // ========================================
                case "ABHANumber":
                    TokenStorage.saveAbhaNumber(clean(value));
                    WorkflowStorage.save("abhaNumber", clean(value));
                    break;


                // ========================================
                // ABHA ADDRESS
                // ========================================
                case "abhaAddress":
                    TokenStorage.saveAbhaAddress(clean(value));
                    WorkflowStorage.save("abhaAddress", clean(value));
                    break;


                // ========================================
                // INDEX
                // ========================================
                case "index":
                    WorkflowStorage.save("index", value);
                    break;


                // ========================================
                // MOBILE
                // ========================================
                case "mobile":
                    WorkflowStorage.save("mobile", value);
                    break;


                // ========================================
                // EMAIL
                // ========================================
                case "email":
                    WorkflowStorage.save("email", value);
                    break;
                default:
                    break;
            }
            // =================================================
            // RECURSIVE EXTRACTION
            // =================================================
            extractWorkflowData(value);
        });
};
// ============================================================
// REQUEST INTERCEPTOR
// ============================================================
ABDMApi.interceptors.request.use(
    config => {
        const access =
            TokenStorage.getAccessToken();
        const xToken =
            TokenStorage.getXToken();
        const tToken =
            TokenStorage.getTToken();
        const txnId =
            TokenStorage.getTxnId();
        // =====================================================
        // ALWAYS ALLOW ACCESS TOKEN
        // =====================================================
        if (access) {
            config.headers.Authorization =
                `Bearer ${access}`;
        }
        // =====================================================
        // REQUEST OTP MUST BE CLEAN
        // =====================================================
        const isRequestOTP =
            config.url?.includes(
                "/request-otp-aadhaar/"
            ) ||
            config.url?.includes(
                "/request-otp-abha/"
            ) ||
            config.url?.includes(
                "/request-otp-mobile/"
            );
        if (isRequestOTP) {
            // DO NOT SEND OLD WORKFLOW TOKENS
            delete config.headers["X-Token"];
            delete config.headers["T-Token"];
            delete config.headers["Transaction-Id"];
            console.log(
                "ABDM REQUEST OTP = CLEAN REQUEST"
            );
            console.log(
                "URL:",
                config.url
            );
            console.log(
                "BODY:",
                config.data
            );
            return config;
        }
        // =====================================================
        // NORMAL ABDM WORKFLOW
        // =====================================================
        if (xToken) {
            config.headers["X-Token"] =
                xToken;
        }
        if (tToken) {
            config.headers["T-Token"] =
                tToken;
        }
        if (txnId) {
            config.headers["Transaction-Id"] =
                txnId;
        }
        return config;
    },
    error =>
        Promise.reject(error)
);
// ============================================================
// RESPONSE INTERCEPTOR
// ============================================================
ABDMApi.interceptors.response.use(response => {
    const data = response.data;
    // ========================================================
    // SPECIAL CASE:
    //
    // ABHA OTP VERIFY
    //
    // We identify it by the response structure.
    // ========================================================
    if (data && data.authResult === "success" && data.token && Array.isArray(data.accounts)) {
        handleABHAOTPVerifyResponse(data);
    } else {
        // ====================================================
        // NORMAL RESPONSE
        // ====================================================
        extractWorkflowData(data);
    }
    // ========================================================
    // DEBUG CURRENT WORKFLOW
    // ========================================================
    console.log("========================================");
    console.log("ABDM WORKFLOW AFTER RESPONSE");
    console.log(WorkflowStorage.get());
    console.log("========================================");
    return response;
}, error => Promise.reject(error));
export default ABDMApi;